import PauseCircleOutlined from '@mui/icons-material/PauseCircleOutlined';
import ActionButton from '../action-button';
import { useTranslations } from '@/i18n/use-translations';
import { useFlowMode } from '../../../use-flow-mode';
import { isOrganizeMode } from '@/components/events/helpers/mode.helper';

export default function AddBreak({
  duration,
  onShowForm,
  formDuration,
}: {
  duration?: number;
  onShowForm?: () => void;
  formDuration?: number;
}) {
  const t = useTranslations();
  const mode = useFlowMode();

  // Hide button if form duration >= gap duration
  const shouldHideButton = formDuration !== undefined && duration !== undefined && formDuration >= duration;

  if (shouldHideButton) {
    return null;
  }

  return (
    <ActionButton
      icon={<PauseCircleOutlined fontSize="small" />}
      onClick={onShowForm}
      disabled={isOrganizeMode(mode)}
      label={t('flows.detail.slotList.actions.break.title')}
      dataTestId="add-break-button"
    />
  );
}
